import { formatCurrency } from './currency.js';
import { isNumberUnit } from '@exodus/currency';
export const DUST_THRESHOLD = 1e-6;
export function isDustAmount(amount) {
    return amount > 0 && amount < DUST_THRESHOLD;
}
function isNumberUnitType(obj) {
    return isNumberUnit(obj);
}
const parseAmount = (amount) => {
    if (isNumberUnitType(amount)) {
        return amount.toDefaultNumber();
    }
    if (typeof amount !== 'string') {
        amount = amount.toString();
    }
    amount = amount.replace(/,/g, '');
    return parseFloat(amount);
};
export const canShowPlusSign = (amount) => {
    amount = parseAmount(amount);
    if (isNaN(amount))
        return false;
    return amount > 0 && !isDustAmount(amount);
};
export function formatAssetAmount(amount, { useGrouping = true, maxSignificant = 6, withPlusSign = false } = {}) {
    amount = parseAmount(amount);
    if (isNaN(amount))
        return '0';
    if (amount === 0)
        return '0';
    if (useGrouping && isDustAmount(amount))
        return '0';
    const absStr = Math.abs(amount).toString();
    const integerPart = absStr.split('.')[0];
    const intLength = integerPart.length;
    const roundedToDecimal = formatCurrency(absStr, {
        useGrouping: false,
        maxFraction: maxSignificant,
    });
    const withMaxSignificant = formatCurrency(roundedToDecimal, {
        useGrouping,
        maxSignificant: Math.max(maxSignificant, intLength),
    });
    if (useGrouping && parseFloat(withMaxSignificant) === 0 && amount !== 0) {
        return '0';
    }
    if (amount < 0)
        return `-${withMaxSignificant}`;
    if (withPlusSign && amount > 0)
        return `+${withMaxSignificant}`;
    return withMaxSignificant;
}
export const formatBalance = (balance, asset) => `${formatAssetAmount(balance)} ${asset.displayTicker}`;
